import * as THREE from "three";
import LpApp from "../LpApp.js";

export default class Fox
{
    constructor()
    {
        console.log("Created Fox.");
        this.lpApp = new LpApp();
        

        this.SetModel();
        this.SetAnimation();
        this.SetDebugUI();
    }

    SetModel()
    {
        this.model = this.lpApp.Resources.items.foxModel.scene;
        this.model.scale.set(0.02, 0.02, 0.02);
        this.lpApp.Scene.add(this.model);

        this.model.traverse((child) =>
        {
            if(child instanceof THREE.Mesh) { child.castShadow = true; }
        })
    }

    SetAnimation() {
        this.animation = {};
        this.animation.mixer = new THREE.AnimationMixer(this.model);
        
        this.animation.actions = {};
        this.animation.actions.survey = this.animation.mixer.clipAction(this.lpApp.Resources.items.foxModel.animations[0]);
        this.animation.actions.walk = this.animation.mixer.clipAction(this.lpApp.Resources.items.foxModel.animations[1]);
        this.animation.actions.run = this.animation.mixer.clipAction(this.lpApp.Resources.items.foxModel.animations[2]);
        
        this.animation.actions.current = this.animation.actions.survey;
        this.animation.actions.current.play();
        
        //console.log(this.lpApp.Resources.items.foxModel.animations[1]);

        this.animation.play = (name) =>
        {
            const newAction = this.animation.actions[name];
            const curAction = this.animation.actions.current;
            
            newAction.reset();
            newAction.play();
            newAction.crossFadeFrom(curAction, 1);

            this.animation.actions.current = newAction;
        }


    }

    SetDebugUI()
    {
        const debugUI = this.lpApp.DebugUI;
        if(debugUI.active)
        {
            const folder = debugUI.ui.addFolder('Fox');

            const debugObject = {
                playSurvey: () => this.animation.play('survey'),
                playWalk: () => this.animation.play('walk'),
                playRun: () => this.animation.play('run')
            }

            folder.add(debugObject, 'playSurvey');
            folder.add(debugObject, 'playWalk');
            folder.add(debugObject, 'playRun');
        }
    }

    Update()
    {
        this.animation.mixer.update(this.lpApp.Time.Delta / 1000);
    }



}